module.exports = require('./helpers/bundle-url').getBundleURL('9Iv90') + "logo.c51670a8.svg";